import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthenticationService } from './services/authentication.service';

@Component({
    selector: 'app-authentication',
    imports: [RouterOutlet],
    providers: [AuthenticationService],
    templateUrl: './authentication.component.html',
    styleUrl: './authentication.component.scss'
})
export class AuthenticationComponent implements OnInit {
    ngOnInit(): void {
        // localStorage.clear();
    }
}